import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerLocationContentContainerResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle('de', 'record-it-components', {
    location: {
      LocationContentContainer: {
        noPermissionMessage: 'Zugriff auf Standortdaten wurde verweigert.',
        unavailableMessage: 'Standortdaten sind derzeit nicht verfügbar.'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}